module.exports = __webpack_public_path__ + "img/dingyue.99277a7a.png";